module.exports = __webpack_public_path__ + "static/media/sales-order-slide-7.724dd4e9.jpg";